import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col, message, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import { routes } from "../../../routes/Routes";
import IntegerInput from "../../../components/IntergerInput";
import _AdministratorService from "../../../modules/AdministratorService";

const { Title } = Typography;

const AdministratorProfessionalDetails = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const administratorUserId = localStorage.getItem("administratorUserId");
    const [proffesionalDetails, setProffesionalInfoDetails] = useState({});
    const [form] = Form.useForm();
    const location = useLocation();
    let data = location.state;
    let administratorIdFromProfile = "";
    let fromDashboard = false;

    if (data && data.administratorUserId) {
        administratorIdFromProfile = data.administratorUserId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }
    const [administratorFromProfileID] = useState(administratorIdFromProfile);
    const [isFromDashboard] = useState(fromDashboard);

    useEffect(() => {
        getLoanOfficerInformationByLoanOfficerId();
    }, [])

    useEffect(() => form.resetFields(), [proffesionalDetails]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Id: administratorFromProfileID ? Number(administratorFromProfileID) : Number(administratorUserId),
                ScreenName: "proffesionaldetails",
                JobRole: values.jobRole,
                InstitutionName: values.institutionName,
                OfficeAddress: values.officeAddress,
                City: values.city,
                State: values.state,
                ZipCode: values.zipCode,
                IdentificationNumber: values.idNumber,
            }
            const res = await _AdministratorService.updateBankerData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message)
                if (isFromDashboard) {
                    history.push({ pathname: routes.administratorProfile.path, state: { administratorUserId, } });
                } else {
                    history.push(routes.administratorDashboard.path);
                }

            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const getLoanOfficerInformationByLoanOfficerId = async () => {
        setLoading(true);
        try {
            const resObj = await _AdministratorService.getBankerInformationByBankerId(administratorFromProfileID ? administratorFromProfileID : administratorUserId);
            if (resObj.data) {
                const res = resObj.data.Obj;
                setProffesionalInfoDetails({
                    jobRole: res.JobRole,
                    institutionName: res.InstitutionName,
                    officeAddress: res.OfficeAddress,
                    city: res.City,
                    state: res.State,
                    zipCode: res.ZipCode,
                    idNumber: res.IdentificationNumber,
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.administratorProfile.path, state: { administratorUserId, } });
        } else {
            history.push(routes.administratorPersonalDetails.path);
        }
    }

    return (
        <Spin spinning={loading}>
            <LeftLayout>
               <div className="profile-wrapper">
                    <div className="profile-card">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 30 }}>
                        Administrator Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 24 }}>
                        Professional Details
                    </Title>

                    <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={true}
                        initialValues={proffesionalDetails} >
                        <Row gutter={16} >
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <Form.Item
                                    label="Job Role"
                                    name="jobRole"
                                    rules={[{ required: true, message: "Job Role is required" }]}

                                >
                                    <Input size="large" placeholder="Enter Job Role" maxLength={30} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <Form.Item
                                    label="Institution Name"
                                    name="institutionName"
                                    rules={[{ required: true, message: "Institution Name is required" }]}

                                >
                                    <Input size="large" placeholder="Enter Institution Name" maxLength={300} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                                <Form.Item
                                    label="Office Address (Street Address, P.O Box)"
                                    name="officeAddress"
                                    rules={[{ required: true, message: "Office Address is required" }]}
                                >
                                    <Input.TextArea size="large" placeholder="Enter Office Address (Street Address, P.O Box)" rows={3} maxLength={500} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <Form.Item
                                    label="City"
                                    name="city"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'City is required',
                                        },
                                        {
                                            pattern: /^[A-Za-z\s]+$/,

                                        },
                                    ]}
                                >
                                    <Input
                                        size="large"
                                        placeholder="Enter City"
                                        maxLength={30}
                                        onKeyPress={(e) => {
                                            const char = String.fromCharCode(e.which);
                                            if (!/^[A-Za-z\s]$/.test(char)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <Form.Item
                                    label="State"
                                    name="state"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'State is required',
                                        },
                                        {
                                            pattern: /^[A-Za-z\s]+$/,

                                        },
                                    ]}
                                >
                                    <Input
                                        size="large"
                                        placeholder="Enter State"
                                        maxLength={30}
                                        onKeyPress={(e) => {
                                            const char = String.fromCharCode(e.which);
                                            if (!/^[A-Za-z\s]$/.test(char)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <Form.Item
                                    label="Zip Code"
                                    name="zipCode"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Zip Code is required',
                                        }
                                    ]}
                                >
                                    <IntegerInput placeholder="Enter Zip Code" maxLength={10} />
                                </Form.Item>
                            </Col>
                            {/* <Form.Item
                            label="ID Number"
                            name="idNumber"
                            rules={[{ required: true, message: "Please enter ID number" }]}
                            
                        >
                            <Input size="large" placeholder="Enter ID Number" maxLength={30} />
                        </Form.Item> */}

                            {/* <Form.Item
                        label="Photo Of ID"
                        name="photoOfId"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => Array.isArray(e) ? e : e && e.fileList}
                        extra="Format: png, jpeg     Size: 155k-350k"
                    >
                        <Upload beforeUpload={beforeUpload} maxCount={1}>
                            <Button icon={<UploadOutlined />}>Select a file</Button>
                        </Upload>
                    </Form.Item> */}

                            <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                                <Form.Item>
                                    <div className=" mt10" style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                        <Button
                                            onClick={onBack}
                                            icon={<LeftOutlined />}
                                        >
                                            Go Back
                                        </Button>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            Save And Proceed <RightOutlined />
                                        </Button>
                                    </div>
                                </Form.Item>

                            </Col>
                        </Row>
                    </Form>

                </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default AdministratorProfessionalDetails;